package components



import JQid
import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.js.header
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import kotlinx.html.style

inline fun TagConsumer<HTMLElement>.visitorCounterBadge() =


   img {
      src =
         "https://camo.githubusercontent.com/4ea54a4a131822233ec96cdd00966a539129530ac7ac0cce2b3c88c979857850/68747470733a2f2f76697369746f722d62616467652e6c616f62692e6963752f62616467653f706167655f69643d6368656573656f6e616d6f6e6b65792e6368656573656f6e616d6f6e6b6579"
      alt = ""
      attributes["data-canonical-src"] = "https://visitor-badge.laobi.icu/badge?page_id=cheeseonamonkey.cheeseonamonkey"
      style =
         "max-width: 100%;" +
            "position: fixed; bottom: 0.33em; right: 1.5em;" +
            "transform: scale(1.4,1.15);"
   }

